/* src/app/components/upload/protocol-modal-dialog.component.scss */
.content {
  min-height: 400px;
}
.table {
  width: 100%;
  min-width: 500px;
  margin-top: 10px;
}
.table th {
  font-weight: bold;
}
.actions {
  position: absolute;
  top: 12px;
  right: 12px;
}
.flex {
  display: flex;
}
.line {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 1px;
  background: black;
  z-index: 300;
}
.right-content,
.left-content {
  position: relative;
  max-height: calc(100vh - 280px);
  overflow-x: hidden;
  overflow-y: auto;
}
.show {
  display: block !important;
}
/*# sourceMappingURL=protocol-modal-dialog.component-UIT5AF7K.css.map */
